import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import qrTagSvg from '../assets/brand/QR Tag VL.svg';

// Determine stable frontend URL without circular imports
const getStableFrontendUrl = () => {
  if (process.env.REACT_APP_FRONTEND_URL) {
    return process.env.REACT_APP_FRONTEND_URL.trim();
  }

  const hostname = window.location.hostname;

  // Production
  if (
    hostname === 'app.sideo.in' ||
    hostname === 'sideo.in' ||
    hostname === 'www.sideo.in' ||
    hostname === 'sideo-pre-qr.vercel.app'
  ) {
    return 'https://app.sideo.in';
  }

  // Local dev
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:3000';
  }

  // Staging/preview frontend deployments should use their own frontend origin
  if (hostname.includes('vercel.app')) {
    return window.location.origin;
  }

  return window.location.origin;
};

// QR code placeholder in SVG template (viewBox: 198.43 × 368.5)
// White QR area in SVG: x=33.27, y=204.77, w=131.85, h=132.28
const QR_PLACEHOLDER = {
  leftPercent: (33.27 / 198.43) * 100,
  topPercent: (204.77 / 368.5) * 100,
  widthPercent: (131.85 / 198.43) * 100,
  heightPercent: (132.28 / 368.5) * 100,
};

const BrandedQRCode = ({ qrId, qrCode }) => {
  // Support both new qrId (QR Pool) and legacy qrCode for backward compatibility
  // Use stable frontend URL, not preview/random URLs
  const stableUrl = getStableFrontendUrl();
  const qrUrl = qrId
    ? `${stableUrl}/q/${qrId}`
    : `${stableUrl}/scan/${qrCode}`;

  return (
    <div className="w-full">
      <div className="relative bg-white" style={{ aspectRatio: '198.43 / 368.5', border: '1px solid #d1d5db' }}>
        <img
          src={qrTagSvg}
          className="absolute inset-0 h-full w-full"
          alt="Sideo QR Tag"
          draggable={false}
        />
        <div
          className="absolute"
          style={{
            left: `${QR_PLACEHOLDER.leftPercent}%`,
            top: `${QR_PLACEHOLDER.topPercent}%`,
            width: `${QR_PLACEHOLDER.widthPercent}%`,
            height: `${QR_PLACEHOLDER.heightPercent}%`,
          }}
        >
          <QRCodeCanvas
            value={qrUrl}
            size={405}
            level="H"
            includeMargin={false}
            style={{ width: '100%', height: '100%' }}
          />
        </div>
        {/* Re-overlay the mini Sideo logo from the SVG template on top of the QR code.
            The template embeds the brand logo centred in the QR placeholder; the
            QRCodeCanvas covers it, so we clip-redraw just that region. */}
        <img
          src={qrTagSvg}
          className="absolute inset-0 h-full w-full pointer-events-none"
          alt=""
          aria-hidden
          draggable={false}
          style={{ clipPath: 'inset(68.4% 35.5% 22.4% 39.8%)' }}
        />
      </div>
    </div>
  );
};

export default BrandedQRCode;
